import React from "react"
import Layout from "../shared/components/organisms/layout/layout"
import SEO from "../shared/components/seo"
import useMobileMode from "../shared/hooks/useMobileMode"
import ProductLineContent from "../components/organisms/product-line-content/product-line-content"
import "../shared/_shared/Index.scss"

const HomeSeccionProducto = props => {
    const { isMobile, currentPage } = useMobileMode()
    const dataFiltered = props.pageContext.params
    const cleanLastSlash = slug =>
        slug.substr(-1) === "/" ? slug.substring(0, slug.length - 1) : slug

    const menuInfo = props.pageContext.menuInfo.reduce(
        (acc, { titulo, colorPrincipal, slug }) =>
            acc.concat({
                nombre: titulo.replace("Líneas de Productos > ", ""),
                color: colorPrincipal,
                slug: "/productos/lineas-de-productos/" + cleanLastSlash(slug),
            }),
        []
    )

    return (
        <Layout title={dataFiltered.metaTitulo || ""} isMobile={isMobile} currentPage={currentPage} white={true}>
            <SEO
                title={dataFiltered.metaTitulo || ""}
                description={
                    dataFiltered.metaDescripcion?.metaDescripcion || ""
                }
                slug={"/productos" + props.path}
                image={"https:" + dataFiltered.banner?.bannerDesktop?.file.url}
                lang={props.pageContext.language}
            />
            <ProductLineContent
                slug={cleanLastSlash(props.path)}
                sectionInfo={dataFiltered}
                menuInfo={menuInfo}
                isMobile={isMobile}
            />
        </Layout>
    )
}

export default HomeSeccionProducto
